import React from "react";
import "../css/style.css";
import "../css/bootstrap.css";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useTraceabilityData } from "../contexts/TraceabilityDataContext";

    const Header = () => {
        // const [storedLogo] = useLocalStorage("logo", null);
    const {brandData} = useTraceabilityData();
    // console.log(brandData);
    const storedLogo = brandData?.logo?.image;
    // console.log(storedLogo);
    
    return (
        <>
            {/* Header Top Bar with Hamburger + Logo + Connect */}
            <div className="homepage-navbar shadow mb-auto p-3 bg-primary">
                <div className="d-flex align-items-center">
                    {/* Hamburger Button */}
                    <a
                        className="toggle hc-nav-trigger hc-nav-1 no-underline"
                        href="#"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#navbar-default"
                        aria-controls="navbar-default"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <b className="bg-dark bg-opacity-75 rounded-circle user-icon">
                            <i className="bi bi-list d-flex m-0 h4 text-white"></i>
                        </b>
                    </a>

                    {/* Logo */}
                    <a
                        href="#"
                        className="link-dark text-truncate d-flex align-items-center gap-2 no-underline mx-auto"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#location"
                        aria-controls="location"
                    >
                        <span>
                            <img
                                src={storedLogo}
                                alt="mooMark Logo"
                                className="ml-2 w-[120px] h-[80px] object-cover"
                            />
                        </span>
                    </a>

                    {/* Right Side - Connect Button */}
                    <div className="d-flex align-items-center">
                        <button
                            // data-bs-toggle="offcanvas"
                            // data-bs-target="#mycart"
                            // aria-controls="mycart"
                            className="link-dark text-decoration-none"
                            onClick={() => window.open("https://www.moomark.in/contact-us", "_blank")}
                        >
                            <div
                                style={{
                                    backgroundColor: "#4c922b",
                                    color: "white",
                                    padding: "8px",
                                    borderRadius: "10px",
                                }}
                            >
                                Connect
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            {/* Offcanvas Navbar (Hamburger Menu) */}
            <nav className="navbar navbar-expand-lg navbar-light navbar-default bg-white osahan-second-nav py-0 shadow-sm">
                <div className="container px-0 px-xl-3">
                    <div
                        className="offcanvas offcanvas-start p-4 p-lg-0"
                        id="navbar-default"
                    >
                        {/* Mobile Header Inside Menu */}
                        <div className="d-flex justify-content-between align-items-center mb-2 d-block d-lg-none">
                            <a className="navbar-brand m-0 d-lg-block flex-shrink-0" href="/home">
                                <img
                                    src={storedLogo}
                                    alt="Logo"
                                    className="img-fluid logo-img w-32"
                                />
                            </a>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            ></button>
                        </div>

                        {/* Mobile Search Bar */}
                        
                        {/* Mobile Navigation Links */}
                        <div className="d-block d-lg-none h-100" data-simplebar>
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <a className="nav-link" href="/home">
                                        Home
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/quality-check">
                                        Quality Check
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link">
                                        FAQs
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link">
                                        My Product
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Header;
